import React, { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CalendarCheck, Plug, LogOut, AlertCircle } from "lucide-react";
import { toast } from "sonner";

export const GoogleConnect = ({ returnTo = "/admin" }) => {
  const [status, setStatus] = useState(null);
  const refresh = () => api.get("/google/status").then(r => setStatus(r.data)).catch(() => setStatus({ configured: false, connected: false }));
  useEffect(() => { refresh(); }, []);

  const connect = () => {
    const token = localStorage.getItem("cxoora_token");
    if (!token) { toast.error("Sessione non valida"); return; }
    window.location.href = `${API_BASE}/google/oauth/start?auth=${encodeURIComponent(token)}&return_to=${encodeURIComponent(returnTo)}`;
  };

  const disconnect = async () => {
    try {
      await api.post("/google/disconnect");
      toast.success("Disconnesso");
      refresh();
    } catch (e) { toast.error("Errore"); }
  };

  if (!status) return null;

  if (!status.configured) {
    return (
      <div className="cxo-card p-4 bg-amber-50 border-amber-200 flex items-start gap-3">
        <AlertCircle size={18} className="text-amber-600 shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-amber-900">Integrazione Google non configurata</p>
          <p className="text-xs text-amber-800 mt-0.5">L'amministratore deve impostare <code>GOOGLE_CLIENT_ID</code> e <code>GOOGLE_CLIENT_SECRET</code> nelle variabili d'ambiente.</p>
        </div>
      </div>
    );
  }

  if (status.connected) {
    return (
      <div className="cxo-card p-4 bg-[#E9F8F1] border-[#1F9D6A]/30">
        <div className="flex items-center gap-3">
          <CalendarCheck size={20} className="text-[#1F9D6A]" />
          <div className="flex-1">
            <p className="font-semibold text-slate-900">Google Calendar collegato</p>
            <p className="text-xs text-slate-600">Connesso come <strong>{status.email}</strong></p>
          </div>
          <Button size="sm" variant="outline" onClick={disconnect}><LogOut size={14} className="mr-1" /> Disconnetti</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="cxo-card p-4">
      <div className="flex items-center gap-3">
        <Plug size={20} className="text-[#2D6BFF]" />
        <div className="flex-1">
          <p className="font-semibold text-slate-900">Collega Google Calendar</p>
          <p className="text-xs text-slate-600">Crea eventi e link Meet automaticamente per le tue call.</p>
        </div>
        <Button onClick={connect} className="bg-[#2D6BFF] text-white" data-testid="google-connect-btn">Collega</Button>
      </div>
    </div>
  );
};

export default GoogleConnect;
